import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBack"><Path d="M4.75 4.75V19.25M16.8781 18.9713L8.70884 13.206C7.87132 12.615 7.87131 11.3851 8.70884 10.7941L16.8781 5.02867C17.8709 4.32801 19.25 5.0292 19.25 6.23465V17.7653C19.25 18.9708 17.871 19.672 16.8781 18.9713Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconBack;
